import { call, put, takeEvery } from "redux-saga/effects"

import {

  GET_PAGE_DEFINITIONS,
  ADD_NEW_PAGE_DEFINITION,
  UPDATE_PAGE_DEFINITION,
  DELETE_PAGE_DEFINITION,

} from "./actionTypes"

import {
  getPageDefinitionsSuccess,
  addPageDefinitionSuccess,
  updatePageDefinitionSuccess,
  deletePageDefinitionSuccess,
  pageManagementError
} from "./actions"

import {
  
  getPageDefinitions,
  addNewPageDefinition,
  updatePageDefinition,
  deletePageDefinition,
  

} from "../../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* fetchPageDefinitions() {
  try {
    const response = yield call(getPageDefinitions)
    yield put(getPageDefinitionsSuccess(response))
  } catch (error) {
    yield put(pageManagementError(error))
  }
}

function* onAddNewPageDefinition({ payload: pageDefinition }) {
  try {
    const response = yield call(addNewPageDefinition, pageDefinition)
    yield put(addPageDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {

    yield put(pageManagementError(error))
  }
}

function* onUpdatePageDefinition({ payload: pageDefinition }) {
  try {
    const response = yield call(updatePageDefinition, pageDefinition)
    yield put(updatePageDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(pageManagementError(error))
  }
}

function* onDeletePageDefinition({ payload: guid }) {
  try {
    const response = yield call(deletePageDefinition, guid)
    yield put(deletePageDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(pageManagementError(error))
  }
}

function* pageManagementSaga() {
  
  yield takeEvery(GET_PAGE_DEFINITIONS,fetchPageDefinitions)
  yield takeEvery(ADD_NEW_PAGE_DEFINITION,onAddNewPageDefinition)
  yield takeEvery(UPDATE_PAGE_DEFINITION,onUpdatePageDefinition)
  yield takeEvery(DELETE_PAGE_DEFINITION,onDeletePageDefinition)
}

export default pageManagementSaga